import { BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA } from '../../actions/types'

const initialState = undefined

export default function reducerDetalhamentoFinanceiroEncomenda (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA: {
      if (action.payload) {
        const detalhamento = action.payload.data;

        return detalhamento
      }
      return []
    }

    default: {
      return state
    }
  }
}

